@import "../../variables.scss";

$color-rejected-status: #d4403a;
$color-pending-status: #4488ff;
$color-approved-status: #0ead0e;

.updateDetails {
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1020;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: auto;
  }
  margin-top: 3%;
  max-width: 600px;
  overflow-y: auto;
  background-color: white;

  &__title {
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0.6px;
    line-height: 39px;
  }

  &__subtitle {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0.45px;
    line-height: 24px;
    max-width: 600px;
  }

  &__description {
    margin-top: 65px;
  }

  &__checkbox {
    font-weight: bold;
  }
}

.generalConsentModal {
  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1020;
    display: flex;
    justify-content: center;
    background-color: white;
  }
  margin-top: 5%;
  max-width: 600px;
  overflow-y: auto;

  &__title {
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0.6px;
    line-height: 39px;
  }

  &__subtitle {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0.45px;
    line-height: 24px;
    max-width: 600px;
  }

  &__description {
    margin-top: 65px;
  }

  &__checkbox {
    font-weight: bold;
  }
}

.rightToWork {
  &__imageField {
    &__helpText {
      display: flex;
      justify-content: space-between;

      & > div {
        flex-basis: 49%;

        &:only-child {
          flex-grow: 1;
        }
      }
    }
  }
}

.profile {

  &__job {
    padding: 20px;
    justify-content: space-between;
    width: 355px;
    border: 1px solid #E2E8F0;

    @media (max-width: $size-md) {
      width: 100%;
    }
  }

  &__april {
    background-image: url("https://www.hrgo.co.uk/media/8244/screenshot-2024-04-05-at-114228.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #e32f00;
    border-radius: 4px;
    padding: 1rem;
    padding-bottom: 1.5rem;
    color: white;
    display: flex;
    margin: "20px";
    @media (max-width: $size-sm) {
      flex-direction: column;
    }
    &_button {
      height: 40px;
      width: 160px;
      margin-top: auto;
      font-weight: bold;
      @media (max-width: $size-md) {
        margin-top: 4rem;
        width: 100%;
      }
    }
  }
  &__snackbar {
    background: linear-gradient(
      180deg,
      rgb(73, 80, 87) 0%,
      rgb(60, 65, 70) 100%
    );
    border-radius: 4px;
    padding: 1rem;
    padding-bottom: 1.5rem;
    color: white;
    display: flex;
    margin: "20px";
    @media (max-width: $size-sm) {
      flex-direction: column;
    }
    &_title {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin: 1rem 0;
      @media (max-width: $size-sm) {
        margin: 0.5rem 0;
      }
    }
    &_description {
      width: 90%;
      display: flex;
      @media (max-width: $size-md) {
        width: 100%;
        font-size: 12px;
        line-height: 14px;
      }
    }
    &_button {
      height: 40px;
      width: 160px;
      margin-top: auto;
      font-weight: bold;
      @media (max-width: $size-sm) {
        margin-top: 1rem;
        width: 100%;
      }
    }
  }
}

.admin_grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
}

.assignment_grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: white;
  padding: 16px;
  align-items: baseline;
}

.rldownload {
  &__agreement {
    padding-right: 0.5rem;
    width: 100%;
    &_custom {
      padding-right: 0.5rem;
      width: 100%;
    }
    &_customTitle {
      margin-left: 35px;
      display: block;
    }
  }
  &__multipleAgreements {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
    &_inner {
      background-color: white;
      padding: 1rem;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      width: 70%;
      max-height: 100vh;
      overflow-y: auto;
      align-items: center;
      @media (max-width: $size-sm) {
        width: 100%;
        border-radius: 0px;
      }
    }
  }
  &__wrapper {
    border-bottom: #d0d0d0 1px solid;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: flex-start;
    padding: 1rem;
    align-items: center;
    @media (max-width: $size-lg) {
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: start;
    }
    @media (max-width: $size-md) {
      padding: 2rem;
    }
  }

  &__wrapper:last-child {
    border-bottom: 0;
  }

  &__wrapper__reading {
    padding: 1rem;
    background-color: #f6f9ff;
    @media (max-width: $size-sm) {
      padding: 16px;
    }
  }

  &__wrapper__reading {
    span {
      flex-grow: 1;
    }
    input {
      margin-right: 10px;
    }
  }

  &__mobile_row {
    display: flex;
    flex-grow: 1;
    align-items: center;
  }

  &__status {
    width: 93px;
    border: 2px solid;
    border-radius: 21px;
    text-transform: uppercase;
    text-align: center;
    padding: 7px 2px;
    font-family: Lato;
    font-size: 18px;
    letter-spacing: 0.34px;
    line-height: 22px;
    display: inline-block;
    font-weight: 700;
    margin-right: 1rem;
    height: 40px;
    flex-shrink: 0;
    @media (max-width: $size-md) {
      order: 1;
      margin-right: 9px;
      margin-bottom: 8px;
      max-height: 40px;
    }
  }

  &__todo {
    background-color: rgba(217, 83, 79, 0.05);
    border-color: $color-rejected-status;
    color: $color-rejected-status;
  }

  &__done {
    background-color: rgba(14, 173, 14, 0.05);
    border-color: $color-approved-status;
    color: $color-approved-status;
  }

  &__pending {
    border-color: #2196f3;
    color: #2196f3;
  }

  &__title {
    flex-grow: 1;
    padding-right: 5px;
    @media (max-width: $size-md) {
      padding-bottom: 9px;
      font-weight: bold;
    }
  }

  &__description {
    color: $color-grey;
    width: 600px;

    @media (max-width: $size-lg) {
      width: 450px;
    }

    @media (max-width: $size-sm) {
      width: 290px;
      margin-top: 15px;
    }
  }

  &__button {
    color: #000;
    border-color: #2196f3;
    background-color: white;
    min-width: 106px;
    @media (max-width: $size-md) {
      flex-grow: 1;
      width: 100%;
      font-weight: bold;
    }

    &:hover {
      color: #000;
    }
    &:disabled {
      color: #000;
      opacity: 0.5;
    }
  }
  &__download {
    color: black !important;
    @media (max-width: $size-md) {
      order: 2;
    }
  }

  &__wrapper:nth-child(odd) {
    @media (max-width: $size-md) {
      background-color: rgba(0, 30, 83, 0.05);
    }
  }

  &__agreementWrapper {
    display: flex;
    flex-direction: column;
    background-color: #f6f9ff;
  }
}